import { queryOptions } from '@tanstack/react-query';
import type { InferResponseType } from 'hono/client';

import { api } from '~/lib/api';
import { i18n } from '~/lib/i18n';

export type CandidateProfileResponse = InferResponseType<
  (typeof api.api.org)[':orgId']['candidates'][':candidateId']['profile']['$get'],
  200
>;

export function candidateProfileQueryOptions(orgId: string, candidateId: string) {
  return queryOptions({
    queryKey: ['candidate-profile', orgId, candidateId] as const,
    queryFn: async (): Promise<CandidateProfileResponse> => {
      const response = await api.api.org[':orgId'].candidates[':candidateId'].profile.$get({
        param: { orgId, candidateId }
      });
      if (!response.ok) throw new Error(i18n.t('errors.unexpected'));
      return response.json();
    },
    refetchInterval: (query) => {
      const status = query.state.data?.cvStatus;
      if (status === 'pending' || status === 'processing') return 3000;
      return false;
    }
  });
}
